import {
    createApp
} from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';

import 'element-plus/theme-chalk/index.css';
import * as ElIcons from '@element-plus/icons-vue'; // 引入 Element Plus 图标库


import store from './store';


import router from './router'; // 引入 router
import './assets/styles.css';




const app = createApp(App);

// 注册所有图标
for (const [key, component] of Object.entries(ElIcons)) {
    app.component(key, component);
}
app.use(ElementPlus, {
    locale: zhCn
});
app.use(router); // 使用 router
app.use(store);
app.mount('#app');